import { useContext } from 'react'
import { IntegrationsContext } from 'src/contexts/IntegrationsContext'

const useIntegrations = () => useContext(IntegrationsContext)
export default useIntegrations
